import { LINK_LIST, LinkConfig } from "./Footer_config";
import { useLocation, Link as ReactRouterLink } from "react-router-dom";
import { ROUTES } from "src/app/constants";
import SimLinkGenerator from "../simLinkGenerator/SimLinkGenerator";
import { SIM_TYPES } from "../simLinkGenerator/types";
import { useAppSelector } from "src/redux/hooks";
import { RootState } from "src/redux/store";
import { LineOfBusiness } from "src/app/types";
import { SEDGWICK_CANADA } from "src/forms/constants";

const Footer = () => {
  const location = useLocation();
  const { lineOfBusiness } = useAppSelector((state: RootState) => state.app);
  const { workersCompensationTpa } = useAppSelector((state: RootState) => state.forms);
  const isCanada =
    lineOfBusiness === LineOfBusiness.WORKERS_COMPENSATION &&
    workersCompensationTpa === SEDGWICK_CANADA;
  const isLandingPage = location.pathname === ROUTES.LANDING_PAGE;
  const isWc = lineOfBusiness === LineOfBusiness.WORKERS_COMPENSATION;
  const isWcDocumentsPage =
    location.pathname === ROUTES.MEDICAL_PANEL_DATA ||
    location.pathname === ROUTES.WORKERS_COMPENSATION_DOCUMENTS;

  // Links that should only appear on WC claim form pages (not on landing page,
  // cargo, IPL, WC documents pages, or any future claim types)
  const wcOnlyLinks = ["Report Missing Site"];

  const renderLinkList = (linkList: LinkConfig[]) => {
    return linkList.map((link, index) => {
      if (wcOnlyLinks.includes(link.label) && (!isWc || isLandingPage || isWcDocumentsPage)) {
        return null;
      }
      if (link.type === "navigation" && link.to) {
        return (
          <ReactRouterLink key={index} to={link.to} target="_blank">
            <span className="footer-link">{link.label}</span>
          </ReactRouterLink>
        );
      }
      if (link.type === "sim") {
        const simType =
          isCanada && link.simType === SIM_TYPES.REPORT_MISSING_SITE
            ? SIM_TYPES.REPORT_MISSING_SITE_CANADA
            : link.simType!;
        return (
          <SimLinkGenerator
            color="inverted"
            variant="primary"
            target="_blank"
            key={index}
            simType={simType}
            reactRouterLink={true}
          >
            <span className="footer-link">{link.label}</span>
          </SimLinkGenerator>
        );
      }
      return (
        <ReactRouterLink to={`${link.to}`} target="_blank" key={index}>
          <span className="footer-link">{link.label}</span>
        </ReactRouterLink>
      );
    });
  };

  return (
    <footer className="app-footer" id="app-footer">
      <div>{renderLinkList(LINK_LIST)}</div>
    </footer>
  );
};
export default Footer;
